import { boot as BootIntercom, shutdown as ShutdownIntercom } from '@intercom/messenger-js-sdk';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  redirectUrl: string = '/';
  token: string = localStorage.getItem('api/token');

  constructor() {}

  isLoggedIn(): boolean {
    if (this.token) {
      try {
        const jwt: any = JSON.parse(atob(this.token.split('.')[1]));
        const date: number = Math.floor(Date.now() / 1000);

        return date < jwt.exp;
      } catch (_: any) {
        return false;
      }
    }

    return false;
  }

  setToken(token: string): void {
    this.token = token;
    localStorage.setItem('api/token', token);
  }

  logout(): void {
    this.token = null;

    if (environment.production) {
      ShutdownIntercom();
      BootIntercom({
        app_id: environment.intercom_app_id,
        Origin: 'KeyToCheck'
      });
    }

    localStorage.removeItem('user');
    localStorage.removeItem('menu');
    localStorage.removeItem('api/token');
    localStorage.removeItem('conciergerie');
    localStorage.removeItem('conciergerie_id');
    localStorage.removeItem('non_payment_reminder_timestamp');
  }

}
